import NotificationService from "Services/notification";

export const LOAD_SINGLE_NOTIFICATION_REQUESTED =
  "LOAD_SINGLE_NOTIFICATION_REQUESTED";
export const LOAD_SINGLE_NOTIFICATION_OK = "LOAD_SINGLE_NOTIFICATION_OK";
export const LOAD_SINGLE_NOTIFICATION_FAIL = "LOAD_SINGLE_NOTIFICATION_FAIL";
export const SINGLE_NOTIFICATION_MARK_AS_READ =
  "SINGLE_NOTIFICATION_MARK_AS_READ";

export function loadNotifications() {
  return async (dispatch) => {
    dispatch({ type: LOAD_SINGLE_NOTIFICATION_REQUESTED });
    try {
      const messages = await NotificationService.loadSingleNotification();
      dispatch({
        type: LOAD_SINGLE_NOTIFICATION_OK,
        messages: Array.isArray(messages?.items) ? messages.items : [],
      });
    } catch (e) {
      dispatch({
        type: LOAD_SINGLE_NOTIFICATION_FAIL,
        e,
      });
    }
  };
}

export function markAsRead(message) {
  return async (dispatch) => {
    const newMessage = await NotificationService.markAsRead(message);
    dispatch({
      type: SINGLE_NOTIFICATION_MARK_AS_READ,
      message: newMessage,
    });
  };
}
